import React, {useEffect, useState} from 'react';
import { TextField, Button, CircularProgress, Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { axiosWithAuth } from '../utils/axiosWithAuth';
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction';
import styled from 'styled-components';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const initialEvent = {
    eventname: '',
    description: '',
    date: '',
    location: '',
}

const Form = styled.form`
    max-width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 20% 0;
    margin-top: 25%;
    margin-bottom: 10%;
    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        max-width: 80%;
        margin-top: 28%;
        border: 1px grey solid;
        border-radius: 1.4%;
        padding: 2% 0;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        border: 1px grey solid;
        margin-top: 10%;
        border-radius: 1.4%;
        max-width: 45%;
    }
`

const StyledTF = styled(TextField)`
    width: 80%;
`

const AddEvent = (props) => {
    const [event, setEvent] = useState(initialEvent)
    let history = useHistory()
    let dispatch = useDispatch()

    let roles = useSelector(state => state.userInfo)

    const inputHandler = (e) => {
        e.preventDefault()
        setEvent({...event, [e.target.name]: e.target.value})
    }

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type: ERROR, payload: ''})
        if (event.description && event.description.trim().length-1 > 250){
            dispatch({type: ERROR, payload: 'Description cannot contain more than 250 characters'})
            return
        }
        // if (!event.eventname || !event.date || !event.location) return 
        dispatch({type: LOADING, payload: ''})
        const eventDetail = {
            'eventname': event.eventname ? event.eventname : "TBA",
            'description': event.description.trim(),
            'date': event.date ? event.date : "TBA",
            'location': event.location ? event.location : "TBA"
        }
        axiosWithAuth()
            .post(`/events/event/`, eventDetail)
            .then(res => {
                dispatch({type: ERROR, payload: 'SUCCESS'})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
            .finally(()=>{
                history.push('/event')
                dispatch({type: LOADING_OFF, payload: ''})
            })
    }

    const cancelHandler = (e) => {
        e.preventDefault()
        setEvent(initialEvent)
        history.push('/event')
    }

    useEffect(() => {
        if (roles && roles.roles[0].role.name === "MEMBER") {
            history.push('/event')
        }
    },[roles])

    return (
        <>
            {!event ? <CircularProgress /> : 
            <>
                <Form onSubmit={submitHandler}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <h4>ADD EVENT</h4>
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Event Name'
                            variant="filled"
                            name='eventname'
                            value={event.eventname}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Description'
                            variant="filled"
                            name='description'
                            value={event.description}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Date'
                            variant="filled"
                            name='date'
                            value={event.date}
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Location'
                            variant="filled"
                            value={event.location}
                            name='location'
                            onChange={inputHandler}
                            type='text'
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction={"row"} spacing={2} justify={"center"}>
                            <MuiThemeProvider theme={greenTheme}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={cancelHandler}>
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button type='submit' variant="contained" color="primary">
                                        Add
                                    </Button>
                                </Grid>
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                </Grid>
                </Form>
            </>}
        </>
    )
}

export default AddEvent